"use client"

import type { ReactNode } from "react"

import { cn } from "../../lib/utils"

type MarqueeProps = {
  items: ReactNode[]
  className?: string
  speed?: number
}

export function Marquee({ items, className, speed = 30 }: MarqueeProps) {
  const content = [...items, ...items]

  return (
    <div className={cn("overflow-hidden", className)}>
      <div
        className="flex w-max gap-4"
        style={{ animation: `marquee ${speed}s linear infinite` }}
      >
        {content.map((item, index) => (
          <div key={index} className="shrink-0">
            {item}
          </div>
        ))}
      </div>
    </div>
  )
}

export function Ticker({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div className={cn("overflow-hidden whitespace-nowrap", className)}>
      <div className="inline-flex animate-[ticker_25s_linear_infinite] gap-8">
        {children}
        {children}
      </div>
    </div>
  )
}
